import { useMemo } from 'react'
import { Typography } from 'antd'

export const TagSearchOption = tagTreeOptions => {
  const treeData = useMemo(
    () =>
      tagTreeOptions?.map((item, index) => {
        const parentId = `parent_${index}`
        const parent = {
          id: parentId,
          name: item.tagCategoryName,
          total: item.bindTotal,
          children: [],
        }

        if (item.tagList && item.tagList?.length > 0) {
          parent.children = item.tagList?.map(tag => ({
            id: tag.tagId,
            name: tag.tagName,
            total: tag.bindTotal,
          }))
        }

        return parent
      }),
    [tagTreeOptions],
  )

  const createVNode = node => ({
    value: `${node.name}$${node.id}`,
    title: (
      <div
        style={{
          display: 'flex',
          fontSize: 14,
        }}
      >
        <Typography.Text
          ellipsis={{ tooltip: { getPopupContainer: () => document.body } }}
          style={{ maxWidth: 200 }}
        >
          {node.name}{' '}
          <span style={{ marginLeft: 5 }}>
            (<span style={{ color: '#2090a8' }}>{node.total}</span>)
          </span>
        </Typography.Text>
      </div>
    ),
  })

  const data = treeData?.map(item => {
    if (item.children) {
      return {
        value: item.name,
        title: (
          <div
            style={{
              display: 'flex',
              fontSize: 14,
            }}
          >
            <Typography.Text
              ellipsis={{ tooltip: { getPopupContainer: () => document.body } }}
              style={{ maxWidth: 200 }}
            >
              {item.name}{' '}
              <span style={{ marginLeft: 5 }}>
                (<span style={{ color: '#2090a8' }}>{item.total}</span>)
              </span>
            </Typography.Text>
          </div>
        ),
        children: item.children?.map(child => createVNode(child)),
      }
    } else {
      return {
        value: item.name,
        title: (
          <div
            style={{
              display: 'flex',
              fontSize: 14,
            }}
          >
            <Typography.Text
              ellipsis={{ tooltip: { getPopupContainer: () => document.body } }}
              style={{ maxWidth: 200 }}
            >
              {item.name}{' '}
              <span style={{ marginLeft: 5 }}>
                (<span style={{ color: '#2090a8' }}>{item.total}</span>)
              </span>
            </Typography.Text>
          </div>
        ),
      }
    }
  })

  return data
}
